export const initialValuesPerson = {
  last_name: "",
  first_name: "",
  email: "",
  phone: "",
  comment: "",
};
